var exports = {
  "aH": "x7f9a0e16--e8ff7d--header-container",
  "wx": "x7f9a0e16--e8ff7d--header",
  "Qs": "x7f9a0e16--e8ff7d--content",
  "ne": "x7f9a0e16--e8ff7d--controls",
  "DD": "x7f9a0e16--e8ff7d--title",
};

module.exports = exports;
